import * as React from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ErrorBoundary } from 'react-error-boundary';

import OverlaySpinner from '../../common/OverlaySpinner/OverlaySpinner';

export interface ILoadingErrorBoundaryRTKProps {
  children: React.ReactNode | React.ReactNode[];
  isLoading: boolean;
  error: FetchBaseQueryError | undefined;
  fallbackLoading?: React.ReactNode;
  fallbackError?: React.ReactNode;
}

/**
 * A component that handles loading and error states for Redux RTK Query
 * @param children - The children to render
 * @param isLoading - Whether the data is still loading
 * @param error - The error object
 * @param fallbackLoading - The fallback component to render when loading
 * @param fallbackError - The fallback component to render when there is an error
 */

const LoadingErrorBoundaryRTK = ({
  children,
  isLoading,
  error,
  fallbackLoading,
  fallbackError,
}: ILoadingErrorBoundaryRTKProps) => {
  if (isLoading) {
    return fallbackLoading ? <>{fallbackLoading}</> : <OverlaySpinner removeBgColor />;
  }

  if (error) {
    return fallbackError ? (
      <>{fallbackError}</>
    ) : (
      <div>
        Oh no! Something went wrong. <br /> Status:
        {error.status}
      </div>
    );
  }

  return <ErrorBoundary fallback={<div>Something went wrong</div>}>{children}</ErrorBoundary>;
};

export default LoadingErrorBoundaryRTK;
